import classNames from 'classnames';
import React, { FunctionComponent, ReactNode } from 'react';
import styles from './TemplateBuilderComponents.module.css';

interface Props {
  children: ReactNode;
}

export const TemplateBuilderInputTriggerSection: FunctionComponent<Props> = ({
  children,
}) => (
  <div
    className={classNames(
      styles.subsection,
      styles.inputTriggerDataCollectionContainer,
    )}
  >
    <div className={styles.subsectionHeading}>
      Input Trigger Data Collection
    </div>
    {children}
  </div>
);
